export const industry_offer_content_en = {
    general: {
        brandOverviewFallback: 'Hellenic NLP Academy is an educational organization specialized in Neuro-Linguistic Programming (NLP), offering certification programs, seminars and one-to-one coaching. The brand focuses on practical personal and professional development, with emphasis on communication, mindset and goal achievement. It serves both individuals and professionals who seek real self-improvement through structured training and practical tools. Overall, Hellenic NLP Academy is a stable and trusted personal-development education brand with clear methodology and consistent learning outcomes.',
        digitalChannels: {
            triggers: ['social_media_management', 'meta_ads', 'google_ads', 'email_marketing', 'tiktok_ads', 'blog', 'email_journey', 'profile_creation'],
            items: ['Facebook', 'Instagram', 'Meta Ads', 'Google Ads', 'Email Marketing']
        },
        socialManagement: {
            triggers: ['social_media_management'],
            items: [
                'Creation of posts for Facebook and Instagram.',
                '9 posts / 30 days based on plan.',
                'Content will be produced using professional photography and graphic material.',
                'Copywriting is prepared by the Provider after market and industry research.',
                'Stories are published with client branding and designed copy from available material.'
            ]
        },
        contentFlow: {
            triggers: ['social_media_management'],
            steps: [
                {
                    title: 'Idea Production',
                    lines: [
                        'Planning ideas for the upcoming period.',
                        'Sending idea draft to the Client.',
                        'Revisions and idea adjustments.',
                        'Client approval.'
                    ]
                },
                {
                    title: 'Content Production',
                    lines: [
                        'Visual design production based on approved ideas.',
                        'Copywriting production based on approved ideas.',
                        'Sending the content draft to the Client.',
                        'Final revisions and approval for the upcoming period.'
                    ]
                },
                {
                    title: 'Plan Execution',
                    lines: [
                        'The Provider executes all required actions to follow the approved plan accurately.',
                        'Execution continues until the end of the active period.'
                    ]
                }
            ]
        },
        serviceSections: [
            {
                serviceKeys: ['meta_ads'],
                title: 'Meta Ads',
                items: [
                    'Business Manager account setup and payment method configuration.',
                    'Ad account creation and Meta Pixel installation.',
                    'Campaign creation for Facebook and Instagram.',
                    'Final strategy is adjusted after the meeting with the marketing manager.',
                    'Target area: selected locations agreed with the Client.',
                    'Remarketing campaign setup.',
                    'ROI tracking and monthly performance report.'
                ],
                recommendedBudget: '€200.00 / 30 days'
            },
            {
                serviceKeys: ['google_ads'],
                title: 'Google Ads',
                items: [
                    'Google Analytics and Google Tag Manager setup.',
                    'Conversion tracking activation and configuration.',
                    'Google Ads account setup.',
                    'Performance Max and Search campaign creation.',
                    'Keyword-based targeting for qualified audience reach.',
                    'Target area: selected locations agreed with the Client.',
                    'Ad copy creation (headlines and descriptions) based on business USPs.'
                ],
                recommendedBudget: '€300.00 / 30 days'
            },
            {
                serviceKeys: ['tiktok_ads'],
                title: 'TikTok Ads',
                items: [
                    'TikTok Ads account setup and optimization.',
                    'Campaign planning based on target audience and KPIs.',
                    'Creative adaptation per campaign objective.',
                    'Performance tracking and monthly report.'
                ],
                recommendedBudget: '€600.00 / 30 days'
            },
            {
                serviceKeys: ['email_marketing'],
                title: 'Email Marketing',
                items: [
                    'Email platform setup for automated email workflows.',
                    'Creation of welcome emails, newsletters, abandoned cart emails and re-engagement emails.',
                    'Continuous KPI-based optimization (open rates, CTR, conversions).',
                    'Email list management and audience segmentation.',
                    'Email content production.'
                ]
            }
        ],
        prerequisitesItems: [
            'Logo and brand kit.',
            'Functional website.',
            'Access to Google Ads, Analytics and Tag Manager accounts.',
            'Access to Meta accounts (Business Manager, Pixel, Meta ad account).',
            'Admin access to Facebook and Instagram profiles.',
            'Clear business goals, service priorities and target audience definition.',
            'Photo material for social and ad usage.'
        ],
        assumptionsItems: [
            'Business profile management for active social presence.',
            'Meta campaign creation and optimization.',
            'Email marketing campaign creation and optimization.',
            'General remarketing for website visitors and social engagement.',
            'Google campaign creation and management.',
            'Conversion tracking setup and ongoing monitoring.',
            'Monthly performance report with analysis.'
        ],
        outOfScopeItems: [
            'Website structure/design rebuilds.',
            'Management and publishing on additional social platforms.'
        ],
        finalTerms: [
            {
                title: '1. Financial Terms',
                points: [
                    'a. This offer covers account and/or ad management services only, not ad spend.',
                    'b. Service payments are completed according to the agreed pricing and billing cycle.',
                    'c. In case of delayed payment, the Provider may pause services until settlement.'
                ]
            },
            {
                title: '2. Working Hours and Support',
                points: [
                    'a. Provider working hours: Monday to Friday, 09:00-17:00 (GMT+2), excluding holidays.',
                    'b. Requests outside working hours are queued for the next business day.'
                ]
            },
            {
                title: '3. Confidentiality Terms',
                points: [
                    'a. This proposal is confidential and intended only for the Client and authorized partners.',
                    'b. Provider and Client keep all cooperation-related information confidential.'
                ]
            },
            {
                title: '4. Timeline and Performance',
                points: [
                    'a. Tasks are handled by priority. Minimum delivery time: one business day.',
                    'b. Each new step starts only after the previous one is completed and approved.',
                    'c. The Provider does not proceed without active subscription or settled obligations.',
                    'd. The Provider is not liable for delays caused by missing communication, approval delays, missing material or force majeure.',
                    'e. In other delay cases, the Provider must notify the Client.'
                ]
            },
            {
                title: '5. Intellectual Property and Ownership',
                points: [
                    'a. Strategy and ad campaign structure remain Provider property unless otherwise agreed in writing.',
                    'b. Client-facing produced content is transferred to the Client upon full payment.'
                ]
            },
            {
                title: '6. Start and Duration',
                points: [
                    'a. Offer acceptance is completed with the subscription payment.',
                    'b. Subscription renews automatically every 30 days unless otherwise agreed or cancelled.'
                ]
            },
            {
                title: '7. Termination',
                points: [
                    'a. Either party may terminate with a 30-day written notice.',
                    'b. Upon termination, the Provider may remove campaigns unless otherwise agreed in writing.',
                    'c. Any change is valid only in writing and accepted by both parties.',
                    'd. In disputes, parties attempt amicable resolution first; otherwise Volos courts are competent.'
                ]
            }
        ],
        importantItems: [
            {
                title: 'Recurring Payment Responsibility',
                lines: [
                    'The Client is responsible to complete each billing-cycle payment on time to keep services active.'
                ]
            },
            {
                title: 'Renewal Failure',
                lines: [
                    'If the card has insufficient balance, subscription is paused and then automatically discontinued.'
                ]
            },
            {
                title: 'Payment Link',
                lines: [
                    'The payment link is included in this offer and used to activate agreed services.'
                ]
            }
        ]
    },
    graphic: {
        brandOverviewFallback: 'This project includes professional creative production for business communication and digital promotion. Deliverables are adapted to brand needs and can be used in social channels, ad placements and communication assets.',
        digitalChannels: {
            triggers: ['profile_creation', 'social_media_creation'],
            items: ['Facebook', 'Instagram']
        },
        socialManagement: {
            triggers: [],
            items: []
        },
        contentFlow: {
            triggers: ['video_edit', 'static_ad', 'logos', 'card', 'flyers_banners', 'catalog', 'profile_creation', 'social_media_creation', 'graphics'],
            steps: [
                {
                    title: 'Creative Brief',
                    lines: [
                        'Collection of project goals, concept and key requirements.',
                        'Confirmation of formats, dimensions and usage context.'
                    ]
                },
                {
                    title: 'Creative Production',
                    lines: [
                        'Design/edit production based on approved brief.',
                        'First draft delivery for review.'
                    ]
                },
                {
                    title: 'Revisions and Delivery',
                    lines: [
                        'Implementation of agreed revisions.',
                        'Final files delivered in the agreed formats.'
                    ]
                }
            ]
        },
        serviceSections: [
            {
                serviceKeys: ['video_edit'],
                title: 'Video Edit',
                items: [
                    'Professional video editing for digital usage.',
                    'Delivery in social and ad-ready formats.'
                ]
            },
            {
                serviceKeys: ['static_ad'],
                title: 'Static Ad',
                items: [
                    'Design of static advertising creative.',
                    'Focus on clear messaging and strong brand presence.'
                ]
            },
            {
                serviceKeys: ['logos'],
                title: 'Logos',
                items: [
                    'Logo design aligned with brand identity.',
                    'Final files for digital and print usage.'
                ]
            },
            {
                serviceKeys: ['card'],
                title: 'Card',
                items: [
                    'Business card design aligned with brand style.',
                    'Print-ready final file delivery.'
                ]
            },
            {
                serviceKeys: ['flyers_banners'],
                title: 'Flyers - Banners',
                items: [
                    'Flyer and/or banner design for promotional usage.',
                    'Dimension adaptation per target channel.'
                ]
            },
            {
                serviceKeys: ['catalog'],
                title: 'Catalog',
                items: [
                    'Products/services catalog design in professional structure.',
                    'Layout focus on presentation clarity and usability.'
                ]
            },
            {
                serviceKeys: ['profile_creation', 'social_media_creation'],
                title: 'Social media profile creation',
                items: [
                    'Professional Facebook page creation.',
                    'Professional Instagram profile creation.',
                    'Account linking for future ad utilization.'
                ]
            },
            {
                serviceKeys: ['graphics'],
                title: 'Graphics',
                items: [
                    'Custom graphic production based on project brief.',
                    'Final pricing is defined after final scope confirmation.'
                ]
            }
        ],
        prerequisitesItems: [
            'Logo and brand kit (if available).',
            'Core business information.',
            'Required messages/copy points.',
            'Photo or promotional material (if available).',
            'Clear target and audience definition.'
        ],
        assumptionsItems: [
            'Formatted creatives for social where required.',
            'Static branded creative with required information.',
            'Final delivery in the agreed formats.'
        ],
        outOfScopeItems: [
            'Voice-over recording and audio production.',
            'Content management and posting (unless separately agreed).',
            'Meta or other ad campaign management.',
            'Original video footage production.'
        ],
        finalTerms: [
            {
                title: '1. Financial Terms',
                points: [
                    'a. Production starts after payment confirmation according to this offer.',
                    'b. This offer refers to a one-off creative project.'
                ]
            },
            {
                title: '2. Working Hours and Support',
                points: [
                    'a. Standard working hours: Monday to Friday, 09:00-17:00 (GMT+2), excluding holidays.',
                    'b. Out-of-hours requests are handled next business day.'
                ]
            },
            {
                title: '3. Timeline',
                points: [
                    'a. Production starts after receiving prerequisite material.',
                    'b. Delivery timing depends on review and approval turnaround.'
                ]
            },
            {
                title: '4. Intellectual Property',
                points: [
                    'a. Intellectual property transfers to the Client after full payment.',
                    'b. Provider may use the work as portfolio unless otherwise agreed in writing.'
                ]
            },
            {
                title: '5. Confidentiality',
                points: [
                    'a. Proposal content is confidential and intended only for the Client.',
                    'b. Provider and Client keep cooperation-related information confidential.'
                ]
            }
        ],
        importantItems: [
            {
                title: 'Payment Method',
                lines: [
                    'Creative project payment is one-off.',
                    'Payment completion is made via bank transfer.'
                ]
            }
        ]
    },
    website: {
        brandOverviewFallback: 'This project covers professional website delivery with clear business scope, structured content and technical support for stable operation.',
        digitalChannels: {
            triggers: [],
            items: []
        },
        socialManagement: {
            triggers: [],
            items: []
        },
        contentFlow: {
            triggers: ['plan_starter', 'plan_business'],
            steps: [
                {
                    title: 'Discovery and Scope',
                    lines: [
                        'Definition of business goals, services and required website functionality.',
                        'Finalization of page structure and content requirements.'
                    ]
                },
                {
                    title: 'Design and Development',
                    lines: [
                        'Responsive website implementation based on approved scope.',
                        'Core technical setup and contact form configuration.'
                    ]
                },
                {
                    title: 'Review and Launch',
                    lines: [
                        'Content review, final revisions and approval.',
                        'Website publication to production environment.'
                    ]
                }
            ]
        },
        serviceSections: [
            {
                serviceKeys: ['plan_starter'],
                title: 'Starter Website',
                items: [
                    'WordPress website up to 5 pages with predefined professional structure.',
                    'Visual adaptation on ready layout with brand colors and up to 2 fonts.',
                    'Basic technical SEO setup (titles, meta descriptions, sitemap, indexing) and responsive behavior.'
                ]
            },
            {
                serviceKeys: ['plan_business'],
                title: 'Business Website',
                items: [
                    'WordPress website up to 15 pages with custom homepage structure.',
                    'Full visual customization (custom color palette, up to 2 fonts, responsive behavior).',
                    'Technical implementation with baseline security, contact form, SEO-friendly structure and legal templates.'
                ]
            },
            {
                serviceKeys: ['maintenance_starter'],
                title: 'Web Maintenance Starter',
                items: [
                    'Baseline security review with Wordfence installation and breach notifications.',
                    'Backup retention with one (1) refresh per month.',
                    'Website restore in hacking/data loss events; minimum backup retention for 3 months after end of service.',
                    'Package fixed fee: €10.00 / 30 days (VAT included).'
                ]
            },
            {
                serviceKeys: ['maintenance_business'],
                title: 'Web Maintenance Business',
                items: [
                    'Includes all Starter maintenance services.',
                    'Bug fixes for platform issues appearing during active contract.',
                    'WordPress and plugin essential updates once (1) per month.',
                    'Package fixed fee: €25.00 / 30 days (VAT included).'
                ]
            },
            {
                serviceKeys: ['maintenance_starter', 'maintenance_business'],
                title: 'Improvement Requests and Priority Policy',
                items: [
                    'Improvement requests are sent to webdevelopment@doitforme.eu with project code DOWP and severity level.',
                    'If severity is missing, request is automatically classified as Normal priority.',
                    'Urgent priority: response within 1 business day and immediate implementation kickoff.',
                    'Urgent priority: weekly report with team members, hours, completed parts and total hourly-based cost.',
                    'Normal priority: response within 1 business day and proposal within 5 business days from request (or evaluation meeting).',
                    'Improvements pricing: Urgent priority €30.00 / hour / person (minimum cost €20.00). Normal priority cost is quoted after evaluation.'
                ]
            }
        ],
        prerequisitesItems: [
            'Logo and base brand material.',
            'Final content (text/images) or clear production brief.',
            'Domain/hosting access or details for fresh setup.',
            'Business contact and legal details.'
        ],
        assumptionsItems: [
            'Final website structure is adapted to selected package.',
            'Maintenance scope covers technical support tasks, not new project production.',
            'Maintenance and improvement services require active support package.',
            'Urgent priority requests are billed on actual hourly utilization.'
        ],
        outOfScopeItems: [
            'Custom third-party integrations not previously agreed.',
            'Extended copywriting or product photoshoots.',
            'Advertising campaign management.',
            'Work outside agreed support package without written approval.'
        ],
        finalTerms: [
            {
                title: '1. Financial Terms',
                points: [
                    'a. Selected website package is charged one-off.',
                    'b. Maintenance/management services are charged every 30 days through Stripe based on agreed pricing.',
                    'c. Provider may pause urgent-priority work if payment deadline passes.',
                    'd. Provider is not required to deliver normal-priority work without full payment.',
                    'e. Work outside agreed support scope is billed additionally after written notice and approval.'
                ]
            },
            {
                title: '2. Improvement Request Process',
                points: [
                    'a. Requests are submitted by email including project code DOWP and severity level.',
                    'b. Requests without severity are treated as Normal priority.',
                    'c. For Urgent priority, Provider confirms receipt and starts actions within one (1) business day.',
                    'd. For Normal priority, Provider confirms receipt within one (1) business day and sends proposal within five (5) business days from request or evaluation meeting.'
                ]
            },
            {
                title: '3. Timeline',
                points: [
                    'a. Delivery starts after payment confirmation and receipt of prerequisites.',
                    'b. Improvement work is handled based on priority queue.',
                    'c. Delivery time depends on client approvals and response speed.'
                ]
            },
            {
                title: '4. Support',
                points: [
                    'a. Support hours: Monday to Friday, 09:00-17:00 (GMT+2), excluding holidays.',
                    'b. Out-of-hours requests are handled next business day.'
                ]
            },
            {
                title: '5. Confidentiality Terms',
                points: [
                    'a. Proposal content is confidential and intended only for the Client and authorized partners.',
                    'b. Provider and Client keep all information obtained during cooperation confidential.'
                ]
            },
            {
                title: '6. Intellectual Property',
                points: [
                    'a. Upon full payment, final deliverable ownership is transferred to the Client.',
                    'b. Provider may use the work as portfolio unless otherwise agreed.'
                ]
            },
            {
                title: '7. Start and Duration',
                points: [
                    'a. Cooperation starts after offer acceptance and corresponding first payment.',
                    'b. Active support package is required for maintenance and improvement services.'
                ]
            }
        ],
        importantItems: [
            {
                title: 'Maintenance Payments',
                lines: [
                    'Web maintenance is activated only after recurring payment confirmation.'
                ]
            },
            {
                title: 'Improvements Pricing',
                lines: [
                    'Urgent priority requests: €30.00 / hour / person (minimum cost €20.00).',
                    'Normal priority requests: final cost is defined after request evaluation.'
                ]
            }
        ]
    },
    education: {}
};
